module.exports = __webpack_public_path__ + "img/SES_205258806.99ec1cf9.jpg";